import React, { useEffect } from "react";
import "./JewelleryCustomerPage.css";
import logo from "./jewellery-logo.svg";
import { CUSTOMER_TOKEN, useKodlyLoader } from "./jewelleryDemo";

// Customer assistant of the jewellery demo, on a page of our own in BlueBird's look (not a copy
// of bluebird.pt), with the widget floating as it would on their site.
const IDEAS = [
  {
    title: "Escolher um presente",
    text: "Para quem é, quanto quer gastar, prata ou ouro: as peças que encaixam, com o preço de cada uma.",
  },
  {
    title: "Relógios por especificação",
    text: "Movimento, resistência à água, tamanho e material da caixa, como cada ficha os indica.",
  },
  {
    title: "Tamanhos e serviços",
    text: "O tamanho do anel, a gravação, o embrulho para oferta, trocas, devoluções e garantia.",
  },
  {
    title: "Lojas e Click & Collect",
    text: "Em que loja há a peça, o horário de cada uma e o levantamento em 2 horas.",
  },
];

function JewelleryCustomerPage() {
  useEffect(() => {
    document.title = "Assistente BlueBird · Demonstração";
  }, []);
  useKodlyLoader(CUSTOMER_TOKEN);

  return (
    <div className="jcu-page">
      <header className="jcu-header">
        <img className="jcu-logo" src={logo} alt="BlueBird" />
        <span className="jcu-audience">Demonstração Kodly para a BlueBird</span>
      </header>
      <main className="jcu-main">
        <section className="jcu-hero">
          <p className="jcu-eyebrow">Assistente virtual</p>
          <h1>O conselho de quem conhece cada peça, a qualquer hora.</h1>
          <p className="jcu-lead">
            Conhece as joias e os relógios de bluebird.pt com as suas especificações, as campanhas em curso, as 14
            lojas e os seus horários, e as condições de envio, trocas e garantia. Responde por escrito a quem escreve
            ou envia uma mensagem de voz.
          </p>
          <p className="jcu-try">Experimente no botão em baixo, à direita</p>
        </section>
        <section className="jcu-ideas">
          {IDEAS.map((idea) => (
            <article key={idea.title} className="jcu-idea">
              <h2>{idea.title}</h2>
              <p>{idea.text}</p>
            </article>
          ))}
        </section>
      </main>
      <footer className="jcu-footer">
        Demonstração Kodly com o catálogo, o stock das lojas e as páginas públicas de bluebird.pt.
      </footer>
    </div>
  );
}

export default JewelleryCustomerPage;
